import {
  Box,
  IconButton,
  Stack,
  Tooltip,
  Button,
  Chip,
  Typography,
} from "@mui/material";
import SearchOffRoundedIcon from "@mui/icons-material/SearchOffRounded";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import TabulatedGridCollapsible from "../components/Forms/TabulatedGridCollapsible";
import { keepOnlyCurrentLanguage } from "../helpers/EntityHelper";
import PageContainer from "../components/Forms/PageContainer";
import { useNavigate } from "react-router";
import { useData } from "../contexts/DataContext/DataContextt";
import {
  editClass,
  fetchClasses,
  fetchClassesSimple,
  fetchOcctooClasses,
} from "../services/classService";
import { ClassForm } from "../components/Forms/Class/ClassForm";
import { useState, useCallback, useMemo, useEffect } from "react";
import { usePreload } from "../contexts/DataContext/PreloadContext";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import { usePagedQuery } from "../contexts/hooks/usePagedQuery";
import { classesPageCache } from "./cache/PageCache";
import TabulatedGridCollapsibleV2 from "../components/Forms/TabulatedGridCollapsibleV2";
import { RowActions } from "../utils/RowActions";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";

let ClassesPageNew = () => {
  const { loading, language } = useData();
  const { showNotification } = usePreload();
  const navigate = useNavigate();

  const {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    handleKeyDown,
    handleSearch,
    data: classData,
    total,
    searchTerm,
    isLoading,
    mutate,
    reload,
    searchType,
    setSearchType,
    searchOption,
  } = usePagedQuery({
    fetchFunction: fetchClassesSimple,
    language,
    searchOption: [
      { id: "classCode", display: "Code" },
      { id: "className", display: "Name" },
    ],
    pageSize: 50,
    cache: classesPageCache,
    deps: [language],
  });

  const headers = [
    /*prop: [
        { id: "classDisplayName" },
        { id: "classCode" },
        { id: "classDescription" },
      ],*/
    {
      prop: "classCode",
      text: "Code",
      width: 100,
      minWidth: 100,
      link: {
        action: (row) => handleViewIncludedFeaturesClick(row.classCode),
      },
    },
    {
      prop: "classGroupCode",
      text: "Group Code",
      width: 100,
      minWidth: 100,
    },
    {
      prop: "className",
      text: "Name",
      width: 300,
      minWidth: 300,
    },
    {
      prop: "classDisplayName",
      text: "Display Name",
      width: 300,
      minWidth: 300,
    },
    {
      prop: "classDescription",
      text: "Synonyms",
    },
  ];

  const pageRowActions = [
    /*{
      tooltip: "Edit Class",
      icon: <EditNoteRoundedIcon />,
      onClick: (row) =>
        navigate(`/class/edit/${row.classCode}`, { state: { row } }),
    },*/
    {
      tooltip: "View included features",
      icon: <ViewModuleIcon />,
      onClick: (row) => handleViewIncludedFeaturesClick(row.id),
    },
  ];

  const handleCreateClick = useCallback(
    (id) => {
      navigate(`/classes/new`);
    },
    [navigate, classData],
  );

  const handleViewIncludedFeaturesClick = useCallback(
    (id) => {
      const selectedClass = classData.find((f) => f.classCode === id);
      navigate(`/classes/${id}/includedfeatures`, {
        state: { selectedClass: selectedClass },
      });
    },
    [navigate, classData],
  );

  return (
    <PageContainer
      title="ETIM Class"
      subtitle="Manage ETIM product classes and their included features"
      titleAdornment={
        <Chip
          size="small"
          label={total}
          aria-label={`${total} ${searchTerm ? "matching " : ""}classes`}
        />
      }
      breadcrumbs={[{ title: "ETIM Class" }]}
      actions={
        <Stack direction="row" alignItems="center" spacing={1}>
          <Tooltip
            title="Refresh Etim Class"
            placement="bottom"
            enterDelay={300}
          >
            <div>
              <IconButton
                size="small"
                aria-label="refresh"
                onClick={() => {
                  reload({ force: true });
                }}
              >
                <RefreshIcon />
              </IconButton>
            </div>
          </Tooltip>

          <Button
            variant="contained"
            onClick={handleCreateClick}
            startIcon={<AddIcon />}
          >
            Create
          </Button>
        </Stack>
      }
    >
      {/*
            <Box mt={3}>
                <AddGroupForm onSave={onSave} props={{ row: {}, loading: loading, uploading: uploading, showCancel: false, saveText: 'SAVE' }} />
            </Box>
            */}
      <Box mt={3}>
        <TabulatedGridCollapsibleV2
          variant="modern"
          loading={isLoading}
          emptyState={
            <Stack
              alignItems="center"
              spacing={1.5}
              sx={{ py: 8, color: "text.secondary" }}
            >
              <SearchOffRoundedIcon sx={{ fontSize: 40 }} />
              <Typography>No classes found</Typography>
              {searchTerm && (
                <Button size="small" onClick={() => handleSearch("")}>
                  Clear search
                </Button>
              )}
            </Stack>
          }
          pagination={{
            totalRows: total,
            page: page,
            rowsPerPage: rowsPerPage,
            handleChangePage: handleChangePage,
            handleChangeRowsPerPage: handleChangeRowsPerPage,
            pageSizeOption: [25, 50, 100],
          }}
          search={{
            placeHolder: "Search...",
            searchOption: searchOption,
            searchType: searchType,
            setSearchType: setSearchType,
            handleSearchClick: handleSearch,
            onKeyDown: handleKeyDown,
            activeTerm: searchTerm,
            onClear: () => handleSearch(""),
          }}
          data={classData}
          showHeader={false}
          headers={headers}
          rowActions={(row) => (
            <RowActions row={row} actions={pageRowActions} />
          )}
        />
      </Box>
    </PageContainer>
  );
};

export default ClassesPageNew;
